import Badge from '@cloudscape-design/components/badge';

const SEVERITY_COLORS: Record<string, 'red' | 'blue' | 'grey' | 'green'> = {
  SEV_1: 'red',
  SEV_2: 'red',
  SEV_3: 'blue',
  SEV_4: 'grey',
  SEV_5: 'grey',
  CRITICAL: 'red',
  HIGH: 'red',
  MEDIUM: 'blue',
  LOW: 'green',
};

interface Props {
  severity: string;
}

export function SeverityBadge({ severity }: Props) {
  const color = SEVERITY_COLORS[severity] ?? 'grey';
  return <Badge color={color}>{severity}</Badge>;
}
